import { refIdentityProviderTypeSchema } from '../enums/auth';
import { z } from 'zod';

export const ClaimsPermissionMapping = z.record(z.string(), z.array(z.number()));
export type ClaimsPermissionMappingType = z.infer<typeof ClaimsPermissionMapping>;

export const ClaimsRolesMapping = z.record(z.string(), z.array(z.number()));
export type ClaimsRolesMappingType = z.infer<typeof ClaimsRolesMapping>;

export const ClaimsBrandMapping = z.record(z.string(), z.array(z.number()));
export type ClaimsBrandMappingType = z.infer<typeof ClaimsBrandMapping>;

export const identityProviderDataIConnectSchema = z.object({
  typeId: z.literal(refIdentityProviderTypeSchema.enum.VeevaIConnect),
  connectedAppIdentifier: z.string(),
  requiredClaims: z.array(z.string()).nullable().optional().default([]),
  claimsToPermissions: ClaimsPermissionMapping.nullable().optional().default({}),
  claimsToRoles: ClaimsRolesMapping.nullable().optional().default({}),
  claimsToBrands: ClaimsBrandMapping.nullable().optional().default({}),
});

export const identityProviderDataOIDCSchema = z.object({
  typeId: z.literal(refIdentityProviderTypeSchema.enum.OIDC),
  authorizationCallback: z.string(),
  connectedAppIdentifier: z.string(),
  requiredClaims: z.array(z.string()).nullable().optional().default([]),
  claimsToPermissions: ClaimsPermissionMapping.nullable().optional().default({}),
  claimsToRoles: ClaimsRolesMapping.nullable().optional().default({}),
  claimsToBrands: ClaimsBrandMapping.nullable().optional().default({}),
});
export type IdentityProviderDataOIDC = z.infer<typeof identityProviderDataOIDCSchema>;

export const identityProviderDataPWSchema = z.object({
  typeId: z.literal(refIdentityProviderTypeSchema.enum.UsernamePassword),
});

export const identityProviderDataM2MSessionSchema = z.object({
  typeId: z.literal(refIdentityProviderTypeSchema.enum.M2MSession),
});

export const identityProviderDataSentimentSchema = z.object({
  typeId: z.literal(refIdentityProviderTypeSchema.enum.Sentiment),
});

export const identityProviderDataTrinityEdgeSchema = z.object({
  typeId: z.literal(refIdentityProviderTypeSchema.enum.TrinityEdge),
  authorizationCallback: z.string(),
  requiredClaims: z.array(z.string()).nullable().optional().default([]),
  claimsToPermissions: ClaimsPermissionMapping.nullable().optional().default({}),
  claimsToRoles: ClaimsRolesMapping.nullable().optional().default({}),
  claimsToBrands: ClaimsBrandMapping.nullable().optional().default({}),
});
export type IdentityProviderDataTrinityEdge = z.infer<typeof identityProviderDataTrinityEdgeSchema>;

export const identityProviderDataSchema = z.discriminatedUnion('typeId', [
  identityProviderDataOIDCSchema,
  identityProviderDataIConnectSchema,
  identityProviderDataPWSchema,
  identityProviderDataM2MSessionSchema,
  identityProviderDataTrinityEdgeSchema,
  identityProviderDataSentimentSchema,
]);
export type IdentityProviderData = z.infer<typeof identityProviderDataSchema>;
